import * as actionTypes from './actionTypes';

export const uploadingNewFile = () => ({
    type: actionTypes.UPLOADING_NEW_FILE,
});

export const uploadedNewFile = (file) => ({
    type: actionTypes.UPLOADED_NEW_FILE,
    newFile: file
});

export const finishUploading = () => ({
    type: actionTypes.FINISH_UPLOADING_NEW_FILE
});

export const setUploadingFile = (file) => ({
    type: actionTypes.SET_UPLOADING_FILE,
    file
})

export const setNewUploadProgress = (progress) => ({
    type: actionTypes.CHANGE_UPLOAD_PROGRESS,
    progress
})

export const setUploadSpeed = (speed) => ({
    type: actionTypes.CHANGE_UPLOAD_SPEED,
    speed
})

export const setUploadTimeLeft = (timeLeft) => ({
    type: actionTypes.CHANGE_UPLOAD_TIME_LEFT,
    timeLeft
})

export const removedFilesFromFolder = (files) => ({
    type: actionTypes.CHANGED_FILE_FOLDER,
    files
});

export const changeCurrentFolder = (folder) => ({
    type: actionTypes.CHANGED_FOLDER,
    folder
});

export const folderCreated = (folder) => ({
    type: actionTypes.FOLDER_CREATED,
    folder
});

export const currentFolderChanged = (folderId) => ({
    type: actionTypes.CURRENT_FOLDER_CHANGED,
    folderId
});

export const treeFolderAdd = (folder) => ({
    type: actionTypes.FOLDER_TREE_ADD,
    folder
});

export const treeFolderBack = (folder) => ({
    type: actionTypes.FOLDER_TREE_BACK,
    folder
});

export const startingDraggingItem = () => ({
    type: actionTypes.DRAGGING_DRIVE_ITEM
})
export const stoppedDraggingItem = () => ({
    type: actionTypes.FINISH_DRAGGING_ITEM
})

export const addFilesToUploadQueue = (files) => ({
    type: actionTypes.ADD_FILES_UPLOAD_QUEUE,
    files
})

export const shiftFileUploadQueue = () => ({
    type: actionTypes.SHIFT_FILE_UPLOAD_QUEUE,
})

export const removeFileUploadQueue = (fileName) => ({
    type: actionTypes.REMOVE_FILE_UPLOAD_QUEUE,
    fileName
})

export const setTrashFiles = (files) => ({
    type: actionTypes.SET_TRASH,
    files
})

export const addFilesToTrash = (files) => ({
    type: actionTypes.ADD_FILE_TO_TRASH,
    files
})

export const removeFileFromTrash = (fileId) => ({
    type: actionTypes.REMOVE_FILE_FROM_TRASH,
    fileId
})

export const setFileTrashLoading = (fileId, loading) => ({
    type: actionTypes.EDIT_FILE_TRASH_LOADING,
    data: {fileId, loading}
})

export const setAllFilesTrashLoading = () => ({
    type: actionTypes.SET_ALL_TRASH_LOADING
})
